// Form submission logic
import { makeApiRequest } from '../config/api.js';

/**
 * Submit booking form data
 * @param {Object} formData
 * @returns {Promise<Object>}
 */
export async function submitBookingForm(formData) {
    console.log('Submitting booking form with data:', formData);
    
    try {
        // Try the new v2 endpoint first
        console.log('Trying v2 booking endpoint...');
        const result = await makeApiRequest('/submit-booking', {
            method: 'POST',
            body: JSON.stringify(formData),
        });
        console.log('v2 booking endpoint success:', result);
        return result;
    } catch (error) {
        console.error('Error submitting booking with v2 endpoint:', error);
        try {
            // Fallback to original endpoint
            console.log('Trying v1 booking endpoint as fallback...');
            const result = await makeApiRequest('/submit-booking', {
                method: 'POST',
                body: JSON.stringify(formData),
            });
            console.log('v1 booking endpoint success:', result);
            return result;
        } catch (fallbackError) {
            console.error('Error submitting booking with fallback endpoint:', fallbackError);
            throw new Error(fallbackError.message || 'Failed to submit booking. Please try again later.');
        }
    }
}

/**
 * Submit contact form data
 * @param {Object} formData
 * @returns {Promise<Object>}
 */
export async function submitContactForm(formData) {
    console.log('Submitting contact form with data:', formData);
    
    try {
        // Try the new v2 endpoint first
        console.log('Trying v2 contact endpoint...');
        const result = await makeApiRequest('/submit-contact', {
            method: 'POST',
            body: JSON.stringify(formData),
        });
        console.log('v2 contact endpoint success:', result);
        return result;
    } catch (error) {
        console.error('Error submitting contact with v2 endpoint:', error);
        try {
            // Fallback to original endpoint
            console.log('Trying v1 contact endpoint as fallback...');
            const result = await makeApiRequest('/submit-contact', {
                method: 'POST',
                body: JSON.stringify(formData),
            });
            console.log('v1 contact endpoint success:', result);
            return result;
        } catch (fallbackError) {
            console.error('Error submitting contact with fallback endpoint:', fallbackError);
            throw new Error(fallbackError.message || 'Failed to submit contact. Please try again later.');
        }
    }
}
